<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("orders") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <!-- <div class="col-lg-6 col-5 text-right">
                    <base-button
                        size="md"
                        type="neutral"
                        @click="handleCreate()"
                        >ตัวแทน</base-button
                    >
                </div> -->
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
                        <div class="row">
                            <div class="col-md-2">
                                <base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        :placeholder="$t('time_from')"
                                        class="form-control datepicker"
                                        v-model="params.time_from"
                                    >
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true }"
                                        :placeholder="$t('time_to')"
                                        class="form-control datepicker"
                                        v-model="params.time_to"
                                    >
                                    </flat-picker>
                                </base-input>
                            </div>

                            <div class="col-lg-3">
                                <base-input
								:label="keywordType"
                                    v-model="params.order_number"
                                    placeholder="หมายเลขสั่งซื้อ, เบอร์โทร, ชื่อ, Tracking"
									v-on:keyup.enter="handleSearch"
                                >
                                </base-input>
                            </div>

                            <div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="params.bo_user_id"
                                        :placeholder="$t('menu.user')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in OptionUserTable"
                                            :key="option.UserID"
                                            :label="option.fname + ' ' + option.lname"
                                            :value="option.UserID"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

                            <!-- <div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="params.bo_team_id"
                                        :placeholder="$t('menu.team')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in OptionTeamTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div> -->

                            <div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="params.order_status"
                                        :placeholder="$t('menu.order_status')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in OrderStatusTable"
                                            :key="option.ID"
                                            :label="option.Name"
                                            :value="option.ID"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="params.payment_method_type"
                                        :placeholder="$t('payment_method_type')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in PaymentMethodTypeTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="params.date_type"
                                        :placeholder="$t('sort_type')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in SortTypeTable"
                                            :key="option.ID"
                                            :label="option.Name"
                                            :value="option.ID"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="params.bo_sale_channel_id"
                                        :placeholder="$t('sale_channel')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in SaleChannelTableWithAll"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="params.bo_sale_channel_type_id"
                                        :placeholder="$t('sale_channel_type')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in SaleChannelTypeTableWithAll"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="params.bo_platform_id"
                                        :placeholder="$t('platform')"
                                        filterable
                                    >
                                        <el-option
                                            v-for="option in PlatformTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

							<!-- <div class="col-lg-2">
                                <base-input
                                    v-model="params.recipient_name"
                                    :placeholder="$t('recipient_name')"
									v-on:keyup.enter="handleSearch"
                                >
                                </base-input>
                            </div> -->

							 <!-- <div class="col-lg-2">
                                <base-input
                                    v-model="params.recipient_phone"
                                    :placeholder="$t('recipient_phone')"
									v-on:keyup.enter="handleSearch"
                                >
                                </base-input>
                            </div> -->

							 <!-- <div class="col-lg-2">
                                <base-input
                                    v-model="params.tracking_number"
                                    :placeholder="$t('tracking_number')"
									v-on:keyup.enter="handleSearch"
                                >
                                </base-input>
                            </div> -->

							<div class="col-lg-2" v-if="showForceFilterDate">
								<base-checkbox 
								v-model="params.force_filter_date" class="mb-3">
								ค้นหาโดยใช้วันที่
								</base-checkbox>
							</div>

                            <div class="col-md-2">
                                <base-button size="md" @click="handleSearch()">
								<i class="fas fa-spinner fa-spin " v-if="isLoading"></i>
                                    {{ $t("search") }}</base-button
                                >
								<base-button size="md" @click="handleExport()" v-if="tableData.length != 0">
                                    {{ $t("Export") }}</base-button
                                >
                            </div>
                        </div>
                    </template>
                    <!-- end header -->

                    <div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                        >
                            <!-- order_number -->
                            <el-table-column
                                align="left"
                                :label="$t('order_number')"
                                min-width="80px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.ID }} </span>
                                </div>
                            </el-table-column>

							<!-- payment_at -->
                            <el-table-column
                                align="left"
                                :label="$t('payment_at')"
                                min-width="120px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.payment_at }} </span>
                                </div>
                            </el-table-column>

                            <!-- created_at -->
                            <!-- <el-table-column
                                align="left"
                                :label="$t('created')"
                                min-width="120px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.created_at }} </span>
                                </div>
                            </el-table-column> -->

                            <!-- order_platform -->
                            <el-table-column
                                align="left"
                                :label="$t('sale_channel')"
                                min-width="100px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    {{
                                        GetSaleChannelName(
                                            row.bo_sale_channel_id
                                        )
                                    }}
                                </div>
                            </el-table-column>

							<el-table-column
                                align="left"
                                :label="$t('payment_method')"
                                min-width="100px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    {{
                                            row.payment_method_name
                                    }}
                                </div>
                            </el-table-column>

                            <!-- recipient_name -->
                            <el-table-column
                                align="left"
                                :label="$t('recipient_name')"
                                min-width="150px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.recipient_name }} </span>
                                </div>
                            </el-table-column>

                            <!-- price -->
                            <el-table-column
                                align="left"
                                :label="$t('price')"
                                min-width="100px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.pay_amount }} </span>
                                </div>
                            </el-table-column>

                            <!-- recipient_phone -->
                            <el-table-column
                                align="left"
                                :label="$t('recipient_phone')"
                                min-width="100px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.recipient_phone }} </span>
                                </div>
                            </el-table-column>

                            <!-- bo_order_user -->
                            <el-table-column
                                align="left"
                                :label="$t('order_user')"
                                min-width="100px"
                            >
                                <div slot-scope="{ row }" class="d-flex">
                                    <span> {{ row.bo_order_user_name }} </span>
                                </div>
                            </el-table-column>

                            <el-table-column
                                align="left"
                                :label="$t('status')"
                                min-width="150px"
                            >
							<div slot-scope="{ row }" class="d-flex">
                                    <template v-if="row.order_status == 100"> <span class="btn btn-sm"> {{ $t("order_status_unpaid")}} </span> </template>
                                    <template v-if="row.order_status == 111"> <span class="btn btn-info btn-sm"> {{ $t("order_status_awaiting_shipment") }} </span></template>
                                    <template v-if="row.order_status == 112"> <span class="btn btn-info btn-sm"> {{ $t("order_status_awaitingcollection") }} </span></template>
                                    <template v-if="row.order_status == 114"> <span class="btn btn-primary btn-sm"> {{ $t("order_status_partiallyshipping") }} </span></template>
                                    <template v-if="row.order_status == 121"> <span class="btn btn-primary btn-sm"> {{ $t("order_status_intransit") }} </span></template>
                                    <template v-if="row.order_status == 122"> <span class="btn btn-primary btn-sm"> {{ $t("order_status_delivered") }} </span></template>
                                    <template v-if="row.order_status == 130"> <span class="btn btn-success btn-sm"> {{ $t("order_status_completed") }} </span></template>
                                    <template v-if="row.order_status == 140"> <span class="btn btn-danger btn-sm"> {{ $t("order_status_cancelled") }} </span></template>
									<template v-if="row.order_status == 141"> <span class="btn btn-danger btn-sm"> {{ $t("order_status_returned") }} </span></template>
                                    <template v-if="row.order_status == 142"> <span class="btn btn-danger btn-sm"> {{ $t("order_status_claimed") }} </span></template>
                                </div>
                            </el-table-column>

                            <el-table-column
                                align="right"
                                :label="$t('actions')"
                                min-width="100px"
                            >
                                <div
                                    slot-scope="{ $index, row }"
                                    class="d-flex"
                                >
                                    <!-- <base-button
                                        @click.native="
                                            handlePayment($index, row)
                                        "
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-edit"></i>
                                    </base-button> -->
                                    <base-button
                                        @click.native="
                                            handleDetail($index, row)
                                        "
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-file"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="tableData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <modal
            :show.sync="showDetailModal"
            modal-classes="modal-secondary modal-xl"
        >
            <div class="row">
                <div class="col-md-12">
                    <h5 class="modal-title">
                        {{ $t("order_detail") }} : {{ orderDetail.ID }} - สถานะ
                        : {{ GetOrderStatus(orderDetail.order_status) }}
                    </h5>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <base-input
                        label="ผู้สั่งซื้อ"
                        :value="orderDetail.recipient_name"
                    ></base-input>
                </div>
                <div class="col-md-3">
                    <base-input
                        label="โทรศัพท์"
                        :value="orderDetail.recipient_phone"
                    ></base-input>
                </div>
				<div class="col-md-3">
                    <base-input
                        label="วันที่"
                        :value="orderDetail.created_at"
                    ></base-input>
                </div>
            </div>

            <div class="row">
                
                <div class="col-md-6" v-if="orderDetail.discount == 0">
                    <base-input
                        label="ราคา"
                        :value="orderDetail.pay_amount"
                    ></base-input>
                </div>
				 <div class="col-md-3" v-if="orderDetail.discount != 0">
                    <base-input
                        label="ส่วนลด"
                        :value="orderDetail.discount"
                    ></base-input>
                </div> 
				 <div class="col-md-3" v-if="orderDetail.discount != 0">
                    <base-input
                        label="ราคา (หักส่วนลด)"
                        :value="orderDetail.pay_amount"
                    ></base-input>
                </div> 
                <div class="col-md-3">
                    <base-input
                        label="ช่องทางการชำระเงิน"
                        :value="orderDetail.payment_method_name"
                    ></base-input>
                </div>
                <div class="col-md-3">
                    <base-input
                        label="พนักงาน"
                        :value="orderDetail.bo_order_user_name"
                    ></base-input>
                </div>
            </div>

			<div class="row" v-if="orderDetail.shipping_cost != 0">
				<div class="col-md-3">
				<base-input
                        label="ค่าจัดส่ง"
                        :value="orderDetail.shipping_cost"
                    ></base-input>
				</div>
			</div>

            <!--  full adress -->
            <div class="row">
                <div class="col-md-8">
                    <base-input
                        label="ที่อยู่"
                        :value="orderDetail.recipient_address_fulladdress"
                    ></base-input>
                </div>
                <div class="col-md-4">
                    <base-input
                        label="หมายเหตุ"
                        :value="orderDetail.seller_note"
                    ></base-input>
                </div>
            </div>
			<div class="row" v-if="orderDetail.order_status == 130">
                <div class="col-md-4">
                    <base-input
                        label="ขนส่ง"
                        :value="orderDetail.shipping_provider_name"
                    ></base-input>
                </div>
                <div class="col-md-4">
                    <base-input
                        label="หมายเลขพัสดุ"
                        :value="orderDetail.shipping_tracking_number"
                    ></base-input>
                </div>
                <div class="col-md-4">
                    <base-input
                        label="ผู้จัดส่ง"
                        :value="orderDetail.bo_shipping_user_name"
                    ></base-input>
                </div>

            </div>
			<hr />
			<div class="row">
				<div class="col-md-12">
					--- สินค้าที่สั่งซื้อ ---
				</div>
			</div>
			<div class="row" v-for="( value) in Detail.order_items" :key="value.id" >
				<div class="col-md-10">
					{{ value.bo_product_name }} : {{ value.bo_product_sku_name  }} 
				</div>
				<div class="col-md-2">x {{ value.quantity }} </div>
			</div>
			<!-- <div class="row">
				<div class="col-md-12">
					--- สินค้าที่ตัดสต๊อก ---
				</div>
			</div>
			<div class="row" v-for="( value) in GetWmsProductSummary()" :key="value.wms_product_id" >
				<div class="col-md-10">
					{{ value.wms_product_name }}  ({{value.barcode }})
				</div>
				<div class="col-md-2">x {{ value.pickup_quantity }} </div>
			</div> -->
            <hr />

			<div class="row"  v-if="!IsCod">
				<div class="col-md-6">
					<base-input
                        label="เวลาที่ชำระเงิน"
                        :value="orderDetail.payment_at"
                    ></base-input>

				</div>
			</div>

			<div class="row" v-if="orderDetail.payment_files != ''">
				<div class="col-md-6">
					<base-input label="หลักฐานการชำระเงิน" >

					<img :src="GetOrderUrl(orderDetail.payment_files)" style="width: 500px; " />
					</base-input>

				</div>
			</div>


            <template slot="footer">
				<!-- Payment Check Success -->
				<button
                    type="button"
                    class="btn btn-md btn-link ml-auto btn-primary text-white"
                    @click="handlePaymentSuccess()"
					 v-if="orderDetail.order_status == 100"
                >
                    {{ $t("payment_success") }}
                </button>
				<!-- Payment Check Fail -->
				<button
                    type="button"
                    class="btn btn-md btn-link ml-auto btn-danger text-white"
                    @click="handlePaymentFail()"
					v-if="orderDetail.order_status == 100"
                >
                    {{ $t("payment_fail") }}
                </button>


                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showDetailModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import { read, utils, writeFile } from 'xlsx'

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
	watch : {
		tableData(){
			console.log("Set page", this.getPaymentCurrentPage)
			this.pagination.currentPage = this.getPaymentCurrentPage
		}
	},
    computed: {
        ...mapGetters({
            tableData: "Order/getData",
            UserTable: "User/getData",
            SaleChannelTable: "SaleChannel/getData",
            SaleChannelTableWithAll: "SaleChannel/getDataWithAll",
            TeamTable: "Team/getData",
            PaymentMethodTable: "PaymentMethod/getData",
            Detail: "Order/getDatum",
            isLoading: "Order/isLoading",
			PaymentMethodTypeTable: "PaymentMethod/getPaymentMethodTypeTableWithAll",
			getPaymentCurrentPage: "Order/getPaymentCurrentPage",
            getOrderCurrentPage: "Order/getOrderCurrentPage",
			OrderStatusTable: "Order/OrderStatusTableWithAll",


            SaleChannelTypeTableWithAll: "SaleChannel/getDataTypeWithAll",
			PlatformTable : "Order/getPlatformTable",
        }),
		IsCod: function() {
			
			let iscod = false
			let payment_method = this.PaymentMethodTable.filter(v=>{
				return v.id == this.orderDetail.bo_payment_method_id
			})

			if (payment_method.length > 0){
				iscod = payment_method[0].type == 2
			}
			return iscod
		},
        // OrderStatusTable: function() {
        //     return [
        //         { ID: 0, Name: "-- สถานะ --" },
        //         { ID: 100, Name: this.$t("order_status_unpaid") },
        //         { ID: 111, Name: this.$t("order_status_awaiting_shipment") },
        //         { ID: 112, Name: this.$t("order_status_awaitingcollection") },
        //         { ID: 114, Name: this.$t("order_status_partiallyshipping") },
        //         { ID: 121, Name: this.$t("order_status_intransit") },
        //         { ID: 122, Name: this.$t("order_status_delivered") },
        //         { ID: 130, Name: this.$t("order_status_completed") },
        //         { ID: 140, Name: this.$t("order_status_cancelled") }
        //     ];
        // },
		SortTypeTable:function(){
			  return [
                { ID: "payment", Name: this.$t("วันที่ชำระเงิน") },
                { ID: "created", Name: this.$t("วันที่สร้าง") }
            ];
		},
        OptionUserTable: function() {
            // return UserTable with all
            var data = this.UserTable;
			return [{ UserID: 0, fname: "-- พนักงาน --",lname:"" }, ...data]
            // data.unshift();
            // return data;
        },
        OptionTeamTable: function() {
            // return TeamTable with all
            var data = this.TeamTable;
            return [{ id: 0, name: "-- ทีม --" }, ...data];
        },
		showForceFilterDate:function(){

			// Disable force filter date
			return false

			// let show = false

			// if (this.params.order_status  != 0) {
			// 	show = true
			// }

			// return show

		},
		keywordType(){
			let keyword = this.params.order_number

			// check is mobile number , number[10] , start with 0 
			var regIsMobileNumber = /^[0]\d{9}$/g;
			var regIsOrderMdfNumber = /MDF\d{1,12}$/gi;
			var regIsOrderNumber = /^\d{1,12}$/g;
			var regIsThaipost = /^[A-Z]{2}\d{9}[A-Z]{2}$/gi;
			var regIsKerry = /^[A-Z]{4}\d{9}$/gi;
			var regIsKerryLazada = /^[A-Z]{5}\d{10}$/gi;

			console.log("Keyword:",keyword)

			if(regIsMobileNumber.test(keyword)){
				return "เบอร์โทรศัพท์";
			}

			// check is order id  ,  start with mdf , number only
			if(regIsOrderMdfNumber.test(keyword)){
				return "หมายเลขสั่งซื้อ";
			}
			
			if(regIsOrderNumber.test(keyword)){
				return "หมายเลขสั่งซื้อ";
			}

			if(regIsThaipost.test(keyword)){
				return "Tracking : Thaipost";
			}

			if(regIsKerry.test(keyword)){
				return "Tracking : Kerry";
			}

			if(regIsKerryLazada.test(keyword)){
				return "Tracking : Kerry";
			}

			//  check is tracking a-zA-Z  =>     EJ133238776TH   KELB013620312


			return  keyword=="" ? "" : "ชื่อผู้สั่งซื้อ"
		},
		keywordTypeID(){
			let keyword = this.params.order_number

			// check is mobile number , number[10] , start with 0 
			var regIsMobileNumber = /^[0]\d{9}$/g;
			var regIsOrderMdfNumber = /MDF\d{1,12}$/gi;
			var regIsOrderNumber = /^\d{1,12}$/g;
			var regIsThaipost = /^[A-Z]{2}\d{9}[A-Z]{2}$/gi;
			var regIsKerry = /^[A-Z]{4}\d{9}$/gi;
			var regIsKerryLazada = /^[A-Z]{5}\d{10}$/gi;

			console.log("Keyword:",keyword)

			if(regIsMobileNumber.test(keyword)){
				return 1;
			}

			// check is order id  ,  start with mdf , number only
			if(regIsOrderMdfNumber.test(keyword)){
				return 2;
			}
			
			if(regIsOrderNumber.test(keyword)){
				return 2;
			}

			if(regIsThaipost.test(keyword)){
				return 3;
			}

			if(regIsKerry.test(keyword)){
				return 3;
			}

			if(regIsKerryLazada.test(keyword)){
				return 3;
			}

			//  check is tracking a-zA-Z  =>     EJ133238776TH   KELB013620312


			return  keyword=="" ? 0 : 4
		},
		SearchParams : function(){

			let keyword = this.params.order_number
			let filter = 1
			if (this.showForceFilterDate){
				filter = this.params.force_filter_date ? 1:0
			}

			return {
				time_from: this.params.time_from,
                time_to: this.params.time_to,
				date_type: this.params.date_type,
                order_status: this.params.order_status == 0 ? [] : [this.params.order_status],
                order_number: this.keywordTypeID == 2 ? this.params.order_number.toUpperCase().replace("MDF","") : "",
				tracking_number: this.keywordTypeID == 3 ? keyword : "",
				recipient_name: this.keywordTypeID == 4 ? keyword:"",
				recipient_phone: this.keywordTypeID == 1 ? keyword : "",
                bo_user_id: this.params.bo_user_id,
                bo_team_id: this.params.bo_team_id,
                bo_payment_method_id: this.params.bo_payment_method_id,
                bo_customer_id: this.params.bo_customer_id,
                bo_sale_channel_id: this.params.bo_sale_channel_id,
                bo_sale_channel_type_id: this.params.bo_sale_channel_type_id,
                bo_payment_status: this.params.bo_payment_status,
                bo_packing_status: this.params.bo_packing_status,
                bo_packing_id: this.params.bo_packing_id,
                shipping_provider_id: this.params.shipping_provider_id,
                bo_platform_id: this.params.bo_platform_id,
				payment_method_type: this.params.payment_method_type,
				sort_type: this.params.sort_type,
				filter_date: filter
			}
		},
    },
    data() {
        return {
            propsToSearch: ["Number", "Email"],
            selectedRows: [],
            showAddModal: false,
            showDetailModal: false,

			

            params: {
                time_from: "",
                time_to: "",
                order_status: 100,
                order_number: "",
                tracking_number: "",
                recipient_name: "",
                recipient_phone: "",
                bo_user_id: 0,
                bo_team_id: 0,
                bo_payment_method_id: "",
                bo_customer_id: "",
                bo_sale_channel_id: 0,
				bo_sale_channel_type_id: 0,
                bo_payment_status: "",
                bo_packing_status: "",
                bo_packing_id: "",
                shipping_provider_id: "",
                bo_platform_id:1, 
				payment_method_type:0,
				sort_type:"payment",
				date_type: "payment",
				force_filter_date:true,
            },

            orderDetail: {
                ID: ""
            },
		
        };
    },
    async mounted() {

		this.params.time_from = moment().add(-5, 'days').format('YYYY-MM-DD');
		this.params.time_to = moment().format('YYYY-MM-DD');
		console.log(this.$route.query)
		if (this.$route.query.bo_sale_channel_id != undefined){
			this.params.bo_sale_channel_id = this.$route.query.bo_sale_channel_id 
		}

		this.listPaymentMethod()
        this.listUser();
        this.listUser();
        this.listTeam();
		this.listData(this.SearchParams);
        await this.listSaleChannel();
		this.pagination.currentPage = this.getPaymentCurrentPage

    },
    methods: {
        ...mapActions({
            createData: "Order/createData",
            updateData: "Order/updateData",
            deleteData: "Order/deleteData",
            listData: "Order/listData",
            listDatum: "Order/listDatum",
            listUser: "User/listData",
            listOrderDetail: "Order/getData",
            listTeam: "Team/listData",
            listSaleChannel: "SaleChannel/listData",
            PaymentSuccess: "Order/updatePaymentStatusSuccess",
            PaymentFail: "Order/updatePaymentStatusFail",
			listPaymentMethod: "PaymentMethod/listData",
            setPaymentCurrentPage: "Order/setPaymentCurrentPage",
            setOrderCurrentPage: "Order/setOrderCurrentPage",
        }),
        GetSaleChannelName: function(id) {
            var result = this.SaleChannelTable.find(x => x.id === id);
            return result != null ? result.name : "-";
        },
		GetWmsProductSummary(){
			if (this.orderDetail.wms_product_summary == null) return [];
			try {
				let summary = JSON.parse(this.orderDetail.wms_product_summary);
				console.log("wms_product_summary",summary)
				return summary;

			} catch (err){
				console.log("wms_product_summary",err)
				return []
			}
		},
        GetOrderStatus(id) {
            var data = this.OrderStatusTable;
            var result = data.find(x => x.ID === id);
            return result != null ? result.Name : "-";
        },
        handleSearch() {
			this.setPaymentCurrentPage(1)
            this.listData(this.SearchParams);
        },
        async handleRefresh() {
			this.setPaymentCurrentPage(this.pagination.currentPage)
            await this.listData(this.SearchParams);
			this.pagination.currentPage = this.getPaymentCurrentPage
        },
        handleDetail($index, row) {
            this.orderDetail = row;
            this.listDatum({ id: row.ID });
            this.showDetailModal = true;
            //
        },
        handleCreate() {
            this.$router.push("/backoffice/orders/create");
        },
        handleExport() {
       
			let i = 0

			let dataExport = this.tableData.map((v) => {
				return {

				NO: i++,
				COMP_ORDER_ID: v.ID,
				INV_NO:v.ID,
				BARCODE_NO: '',
				PRODUCT_IN_BOX: 'น้ำหอม',
				RECEIVER : v.recipient_name,
				RECEIVER_ADDRESS: v.recipient_address_fulladdress,
				RECEIVER_AMPHUR: v.recipient_address_city,
				RECEIVER_PROVINCE: v.recipient_address_province,
				RECEIVER_ZIPCODE: v.recipient_zipcode,
				RECEIVER_TEL: v.recipient_phone,
				WEIGHT: 0,
				PRICE: v.pay_amount,
				INSURE: '',
				INSURE_PRICE: '',
				ORDER_STATUS: v.order_status,
				ORDER_STATUS_NAME: this.GetOrderStatus(v.order_status),
				TRACKING:v.shipping_tracking_number,
				ADMIN_ID: v.bo_order_user_id,
				ADMIN_NAME: v.bo_order_user_name,
				
				}

			})

			const dataWS = utils.json_to_sheet(dataExport)
			const wb = utils.book_new()
			utils.book_append_sheet(wb, dataWS)
			writeFile(wb,'export_orders.xlsx')
        },
        handleEdit(index, row) {
            this.showAddModal = true;

            this.md.ID = row.ID;
            this.md.Email = row.Email;
            this.md.FName = row.FName;
            this.md.LName = row.LName;
            this.md.Type = row.Type;
            this.md.FbID = row.FbID;
            this.md.IsBlock = row.IsBlock;
            this.md.Tel = row.Tel;
            this.md.BirthDay = row.BirthDay;
            this.md.CreatedAt = row.CreatedAt;
            this.md.UpdatedAt = row.UpdatedAt;
        },
		handlePaymentSuccess(){
			let params = {
				id : this.orderDetail.ID,
				payload : {
					bo_payment_method_id : this.orderDetail.bo_payment_method_id
				}
			}
			this.setPaymentCurrentPage(this.pagination.currentPage)
			this.PaymentSuccess(params)
				.then(resp => {
					// this.listData(this.SearchParams);
					this.handleRefresh()
					this.showDetailModal = false;
					swal.fire({
						title: this.$t("update_success"),
						text: ``,
						icon: "success",
						confirmButtonClass: "btn btn-success btn-fill",
						buttonsStyling: false
					});
				})
				.catch(err => {
					console.log(err)
					swal.fire({
						title: "สถานะรายการสั่งซื้อไม่ถูกต้อง",
						text: "",
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
				});
		},
		handlePaymentFail(){
			let params = {
				id : this.orderDetail.ID,
				payload : {
					bo_payment_method_id : this.orderDetail.bo_payment_method_id
				}
			}
			this.setPaymentCurrentPage(this.pagination.currentPage)
			this.PaymentFail(params)
				.then(resp => {
					// this.listData(this.SearchParams);
					this.handleRefresh()
					this.showDetailModal = false;
					swal.fire({
						title: this.$t("update_success"),
						text: ``,
						icon: "success",
						confirmButtonClass: "btn btn-success btn-fill",
						buttonsStyling: false
					});
				})
				.catch(err => {
					console.log(err)
					swal.fire({
						title: "สถานะรายการสั่งซื้อไม่ถูกต้อง",
						text: "",
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
				});

		},
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows;
        },
		GetOrderUrl(filename){
			if (filename == null || filename=="") return "";
			return process.env.VUE_APP_API_BASE_URL + "/files/orders/" + filename
		}

    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
